import { render, staticRenderFns } from "./Sheet.vue?vue&type=template&id=4f5c7f2f&scoped=true&"
import script from "./Sheet.vue?vue&type=script&lang=js&"
export * from "./Sheet.vue?vue&type=script&lang=js&"
import style0 from "./Sheet.vue?vue&type=style&index=0&id=4f5c7f2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c7f2f",
  null
  
)

export default component.exports